import { BaseCrossAnalysisUseCase } from './base-cross-analysis-use-case'
import { IQueryRepository } from '../repositories/i-query-repository'

export class OverlappingRightsUseCase extends BaseCrossAnalysisUseCase {
  readonly id = 'overlapping-rights'
  readonly name = 'Superposición de Derechos sobre el Territorio'

  constructor(queryRepo: IQueryRepository) {
    super(queryRepo)
  }
}
